function getPastThread(id, lastViewedThreads) {
  return lastViewedThreads.reduce((res, thread) => thread.uid === id ? thread : res, null);
}

function upScrollConversation() {
  const conversationContent = document.querySelector('.conversation-content');
  if (conversationContent) {
    conversationContent.scrollTop = conversationContent.scrollHeight;
  }
}

const defParams = {
  '1': {
    title: 'Welcome Message',
    desc: 'Sent when a supporter creates a NEW Account',
    icon: '/icons/auto-welcome.png',
    time: 'AFTER a supporter signs up for a NEW Donor Account',
  },
  '2': {
    title: 'One-Time Donation',
    desc: 'Sent to the supporter after a One-Time Donation',
    icon: '/icons/auto-one-time.png',
    time: 'AFTER a supporter makes a one-time donation',
  },
  '3': {
    title: 'Round-Up Sign Up',
    desc: 'Sent to the supporter after they sign-up to donate Round-Ups',
    icon: '/icons/auto-round-up.png',
    time: 'AFTER a supporter signs up to donate Round-Ups',
  },
  '4': {
    title: 'Round-Up | Monthly',
    desc: 'Sent a day before Round-Up Donations are paid each month',
    icon: '/icons/roundups-created.png',
    time: 'SENT a day before Round-Up Donations are paid each month',
  },
  '5': {
    title: 'Monthly Donation',
    desc: 'Sent after a donor signs up to give Monthly Donation',
    icon: '/icons/auto-monthly.png',
    time: 'AFTER a monthly donation is initially made',
  },
  '6': {
    title: 'Monthly | Recurring',
    desc: 'Sent each month after a Monthly Donation is paid',
    icon: '/icons/monthly-donation.png',
    time: 'AFTER a monthly donation is made each month',
  },
};

export {upScrollConversation, getPastThread, defParams};